module.exports = __webpack_public_path__ + "static/media/logo.coderBR.com.eeb9faa3.svg";